import React from 'react';
import {
  Card,
  CardBody,
  VStack,
  HStack,
  Text,
  Badge,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaKey } from 'react-icons/fa';

const RoleSelectionCard = ({
  addUser,
  handleRoleChange,
  allowedRoles,
  roleConfig,
}) => {
  const modalTextColor = useColorModeValue('gray.800', 'white');
  const subtitleColor = useColorModeValue('gray.600', 'gray.300');
  const borderDefault = useColorModeValue('gray.200', 'gray.600');
  const cardBg = useColorModeValue('white', 'gray.800');
  const colorMode = useColorModeValue('light', 'dark');

  const selectedBgLight = '50';
  const selectedBgDark = '900';

  return (
    <Card
      mb={6}
      boxShadow="sm"
      border="1px solid"
      borderColor={useColorModeValue('gray.200', 'gray.700')}
      bg={cardBg}
    >
      <CardBody>
        <VStack align="start" spacing={4}>
          <HStack spacing={2}>
            <Icon as={FaKey} color="purple.500" />
            <Text fontSize="lg" fontWeight="semibold" color={modalTextColor}>
              Step 1: Select Role
            </Text>
          </HStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            {allowedRoles.map((role) => {
              const config = roleConfig[role];
              const isSelected = addUser.role === role;

              const selectedBg =
                colorMode === 'light'
                  ? `${config.color}.${selectedBgLight}`
                  : `${config.color}.${selectedBgDark}`;

              return (
                <Card
                  key={role}
                  role="button"
                  cursor="pointer"
                  onClick={() => handleRoleChange(role)}
                  borderWidth="1px"
                  borderColor={
                    isSelected ? `${config.color}.400` : borderDefault
                  }
                  bg={isSelected ? selectedBg : cardBg}
                  _hover={{
                    borderColor: `${config.color}.400`,
                    transform: 'translateY(-2px)',
                    boxShadow: 'md',
                  }}
                  transition="all 0.2s"
                  minH="130px"
                >
                  <CardBody p={4}>
                    <HStack align="start" spacing={3}>
                      <Icon
                        as={config.icon}
                        fontSize="22px"
                        color={`${config.color}.400`}
                        mt={1}
                      />

                      <VStack align="start" spacing={1}>
                        <Text fontWeight="semibold" fontSize="sm">
                          {config.label}
                        </Text>

                        <Text fontSize="xs" color={subtitleColor} noOfLines={2}>
                          {config.description}
                        </Text>

                        <Badge
                          mt={2}
                          colorScheme={config.color}
                          variant={isSelected ? 'solid' : 'subtle'}
                          fontSize="10px"
                        >
                          {config.departmentType === 'multiple'
                            ? 'Multiple Departments'
                            : 'Single Department'}
                        </Badge>
                      </VStack>
                    </HStack>
                  </CardBody>
                </Card>
              );
            })}
          </SimpleGrid>
        </VStack>
      </CardBody>
    </Card>
  );
};

export default RoleSelectionCard;
